import { jsonProperty, Serializable } from 'ts-serializable';


class SchedulingCard extends Serializable {

    @jsonProperty(String, null)
    id: string = '';

    @jsonProperty(String, null)
    profissionalFoto: string = '';

    @jsonProperty(String, null)
    profissionalNome: string = '';

    @jsonProperty(String, null)
    profissionalEspecialidade: string = '';

    @jsonProperty(String, null)
    unidadeAtendimentoNome: string = '';

    @jsonProperty(String, null)
    horario: string = '';
}

export default SchedulingCard;